import Component from '../core/Component'
import enquire from 'enquire.js'
import { queries } from '../core/config'
import { toggleClass } from '../utils/dom'
import Scroll from '../services/Scroll'

const STATES = {
    ACTIVE: 'is-active',
    READY: 'is-ready'
}

export default class ProfileTabs extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            tabs: [],
            cards: [],
            bars: [],
            content: null
        }

        this.enquireHandler = {
            match: this.attach,
            unmatch: this.detach
        }

        this.timer = null
        this.duration = 9600 // musi sedet s css .job-Tabs
        this.current = -1
        this.hasStarted = false
    }

    prepare() {
        enquire.register(queries.xlargeUp, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(queries.xlargeUp, this.enquireHandler)
    }

    attach = () => {
        this.ref.tabs.forEach(element => element.addEventListener('click', this.handleTabClick))
        this.cards = this.ref.cards.map(element => Component.getFromElement(element))
        Scroll.on('resize', this.handleResize)
        this.element.classList.add(STATES.READY)
        this.show(0)
    }

    detach = () => {
        this.ref.tabs.forEach(element => element.removeEventListener('click', this.handleTabClick))
        this.ref.tabs.forEach((element, index) => toggleClass(element, STATES.ACTIVE, index === 0))
        this.ref.cards.forEach(element => element.classList.remove(STATES.ACTIVE))
        Scroll.off('resize', this.handleResize)
        this.element.classList.remove(STATES.READY)
        this.ref.content.removeAttribute('style')
        this.stop()
        this.hasStarted = false
    }

    handleResize = () => {
        this.resize()
    }

    handleTabClick = event => {
        const index = this.ref.tabs.indexOf(event.currentTarget)
        this.show(index)
    }

    show(index) {
        if (index === this.current) {
            return
        }

        this.stop()

        if (this.hasStarted) {
            this.cards[this.current].leave()
        } else {
            this.hasStarted = true
            this.ref.content.style.height = this.ref.cards[index].getBoundingClientRect().height + 'px'
        }

        setTimeout(() => {
            this.ref.tabs.forEach((element, i) => toggleClass(element, STATES.ACTIVE, index === i ))
            this.current = index
            this.cards[index].enter()
            this.ref.content.style.height = this.ref.content.scrollHeight + 'px'
            this.resume()
        }, 400)
    }

    resize() {
        this.ref.content.style.height = this.ref.content.scrollHeight + 'px'
    }

    resume() {
        clearTimeout(this.timer)
        this.timer = setTimeout(this.next, this.duration)
    }

    stop() {
        clearTimeout(this.timer)
        this.timer = null
    }

    next = () => {
        const next = (this.current + 1) % this.ref.cards.length
        this.show(next)
    }
}
